import { call, put } from 'redux-saga/effects';
import { arrayToEntityMap } from "lib/data";

import { sendTeachersDataRequest } from "state/fetchSagas";
import { fetchTermsSucceeded } from "state/teachers/actions";

import Term from "state/teachers/entities/Term";

export default function* fetchTerms(action) {
  
  const response = yield call(sendTeachersDataRequest, "get_my_terms");
  
  const termsByID = arrayToEntityMap(Term.fromAppserverValueList, term => term.id, response.data);
  
  yield put(fetchTermsSucceeded(termsByID));
  
}



// WEBPACK FOOTER //
// ./src/state/teachers/sagas/fetchTerms.js